import get from 'lodash.get';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { changeQuantity } from '../../actions/checkoutUIActions';
import { trackFormAction } from '../../helpers/checkoutTracking';
import { VARS } from '../../constants/checkoutConstants';
import styles from './styles/checkoutSelectQuantity.scss';
import { connect } from 'react-redux';

// components
import DynamicQuantity from 'dibs-dynamic-quantity-select';

class CheckoutSelectQuantity extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            customQuantityRendered: false,
        };
    }
    onChange(value) {
        const { customQuantityRendered } = this.state;
        const { transaction, quantity, paymentMethodToken, onChangeQuantity } = this.props;
        const availableQuantity = get(transaction, 'sku.availableQuantity');
        const hasUnlimitedQuantity = get(transaction, 'sku.hasUnlimitedQuantity');
        const quantitySelectOptions = get(transaction, 'sku.quantitySelectOptions') || [];
        const lastOptionValue = get(
            quantitySelectOptions,
            `[${quantitySelectOptions.length - 1}].value`
        );
        const tempQuantity = Number(value) || 0;
        const isValidQuantity =
            tempQuantity > 0 && tempQuantity <= (availableQuantity || VARS.QUANTITY_LIMIT);
        const newQuantity = isValidQuantity ? tempQuantity : 0;
        const hasQuantityUpdated = newQuantity !== quantity;

        if (!customQuantityRendered && hasUnlimitedQuantity && newQuantity === lastOptionValue) {
            this.setState({ customQuantityRendered: true });
        } else if (hasQuantityUpdated) {
            trackFormAction('quantity changed');
            onChangeQuantity({
                quantity: newQuantity,
                paymentMethodToken,
            });
        }
    }
    render() {
        const { transaction, quantity, isProcessing } = this.props;
        const availableQuantity = get(transaction, 'sku.availableQuantity');
        const setSize = get(transaction, 'sku.setSize');
        const quantitySelectOptions = get(transaction, 'sku.quantitySelectOptions') || [];

        return (
            !!quantitySelectOptions && (
                <div className={styles.wrapper} data-tn="checkout-select-quantity-wrapper">
                    <DynamicQuantity
                        size="medium"
                        value={quantity}
                        options={quantitySelectOptions}
                        availableQuantity={availableQuantity || VARS.QUANTITY_LIMIT}
                        soldAsSet={(setSize || 0) > 1}
                        hasAnimatedPlaceholder={false}
                        onChange={this.onChange}
                        disabled={isProcessing}
                    />
                </div>
            )
        );
    }
}

CheckoutSelectQuantity.propTypes = {
    transaction: PropTypes.object.isRequired,
    quantity: PropTypes.number,
    paymentMethodToken: PropTypes.string,
    onChangeQuantity: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool,
};

//connected for now to access dispatch.
const ConnectedCheckoutSelectQuantity = connect(
    ({ transaction, ui }) => ({
        quantity: transaction.quantity,
        paymentMethodToken: transaction.paymentMethodToken,
        isProcessing: ui.isProcessing,
    }),
    dispatch => ({
        onChangeQuantity: payload => changeQuantity(dispatch, payload),
    })
)(CheckoutSelectQuantity);

export { CheckoutSelectQuantity };

export default createFragmentContainer(ConnectedCheckoutSelectQuantity, {
    transaction: graphql`
        fragment CheckoutSelectQuantity_transaction on Transaction {
            sku {
                availableQuantity: quantity
                hasUnlimitedQuantity
                quantitySelectOptions {
                    label
                    value
                }
                setSize
            }
        }
    `,
});
